import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react-lite";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import EstimateResult from "./EstimateResult";
import uiStore from '../stores/uiStore'

const useStyles = makeStyles(theme => ({
    drawer: {
        flexShrink: 0,
        padding: theme.spacing(3),
        height: `${100-100*64/window.innerHeight}vh`,
        overflowY: 'auto'
    },
    toolbar: theme.mixins.toolbar,
    dragger: {
        width: theme.spacing(1),
        marginLeft: -theme.spacing(3),
        top: 0,
        height: `100vh`,
        // left: "0px",
        cursor: "ew-resize",
        zIndex: 100,
        backgroundColor: "#666666",
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        
    },
    draggerBar: {
        width: theme.spacing(2),
        height: 64,
        backgroundColor: '#666666',
        marginLeft: -theme.spacing(2),
        borderTopLeftRadius: 5,
        borderBottomLeftRadius: 5,
        display: 'flex',
        alignItems: 'center',

    }
    
}));

const RightDrawer = observer(() =>{
    const classes = useStyles();
    // const [drawerWidth, setDrawerWidth] = React.useState(uiStore.rightDrawerWidth);
    const drawerWidth = uiStore.rightDrawerWidth
    const handleMouseDown = () => {
        document.addEventListener("mouseup", handleMouseUp, true);
        document.addEventListener("mousemove", handleMouseMove, true);
    };

    const handleMouseUp = () => {
        document.removeEventListener("mouseup", handleMouseUp, true);
        document.removeEventListener("mousemove", handleMouseMove, true);
    };

    const handleMouseMove = useCallback(e => {
        // console.log(e.clientX, document.body.offsetLeft, document.body.offsetParent)
        const newWidth = document.body.clientWidth - e.clientX + document.body.offsetLeft;
        if (newWidth > uiStore.rightDrawerMinWidth && newWidth < uiStore.rightDrawerMaxWidth) {
            // setDrawerWidth(newWidth)
            uiStore.setRightDrawerWidth(newWidth);
        }
    }, []);

    return (
        <div
            className={classes.drawer}
            // variant="permanent"
            style={{ width: drawerWidth }}
        >
            {/* <div className={classes.toolbar} /> */}
            <div onMouseDown={e => handleMouseDown()} className={classes.dragger} >
                <div className={classes.draggerBar}>
                    <DragIndicatorIcon style={{color: 'white'}}></DragIndicatorIcon>
                    {/* <DragIndicatorIcon style={{color: 'white'}}></DragIndicatorIcon> */}
                </div>
                
            </div>
            <EstimateResult />
        </div>
    );
})
export default RightDrawer
